module.exports = __webpack_public_path__ + "static/img/8.04c4f6a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/15/eng/8.png
// module id = ipK2
// module chunks = 0